/**
 * Prefill a CORRECTION of an existing employer Right to Work check.
 *
 * The original check and its evidence are audit records. New submissions
 * create a new check version using the existing secured server endpoint.
 * Reuse only proof already associated with the current tenant-scoped check
 * and explicitly confirmed available by the compliance workflow.
 * Never restore/share a Home Office share code after final verification.
 */
const dateOnly = (value) => {
  if (typeof value !== 'string') return '';
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value);
  return match ? match[1] : '';
};

export function getRTWCheckEditPrefill(check, proofAvailable = false) {
  if (!check?.id) return null;
  const originalProofId = check.proof_document_id || check.evidence_document_id || null;
  const proofId = proofAvailable && originalProofId ? originalProofId : null;
  const originalProofName = check.proof_document?.filename
    || check.proof_document?.original_filename
    || null;

  return {
    form: {
      method: check.method || '',
      checked_at: dateOnly(check.checked_at),
      outcome: check.outcome || 'awaiting_review',
      source_status_type: check.source_status_type || '',
      follow_up_due_at: dateOnly(check.follow_up_due_at),
      permission_type: check.permission_type || '',
      permission_start_date: dateOnly(check.permission_start_date),
      permission_end_date: dateOnly(check.permission_end_date),
      reference_number: check.reference_number || '',
      // Raw codes MUST NOT be put back in editable fields after check completion.
      share_code: '',
      restrictions: check.restrictions || '',
      hours_limit: check.hours_limit === null || check.hours_limit === undefined ? '' : String(check.hours_limit),
      is_indefinite: check.is_indefinite === true,
      follow_up_required: check.follow_up_required === true,
      document_type: check.document_type || '',
      notes: check.notes || '',
    },
    proofId,
    proofName: proofId ? (originalProofName || 'Existing saved proof of check') : null,
  };
}
